<template>
  <custom-dialog
    color="success"
    icon="mdi-plus"
    ref="dialog"
    title="Ajouter un document"
    store-modal
  >
    <div style="width: 65vw; max-width: 800px; margin: auto;">
      <v-form ref="form" v-model="valid">
        <v-text-field
          v-model="title"
          outlined
          label="Titre *"
          :rules="[(text) => text !== '' || 'Vous devez renseigner un titre.']"
        />
        <div class="d-flex">
          <v-select
            v-if="!action"
            label="Nature *"
            v-model="nature"
            :items="categoriesItems"
            outlined
            dense
            :rules="[(nature) => !!nature || 'Vous devez choisir une nature.']"
          />
          <v-checkbox
            label="Visible Extranet"
            color="success"
            v-model="visible"
            class="mx-4"
          />
        </div>
        <v-file-input
          v-model="file"
          label="Fichier *"
          :rules="[(file) => !!file || 'Vous devez choisir un fichier.']"
        />
        <v-textarea outlined v-model="comment" label="Commentaire" />
      </v-form>
    </div>

    <template v-slot:actions>
      <v-btn
        class="mx-2"
        small
        @click="add"
        color="success"
        :loading="isLoading"
        :disabled="!valid"
      >
        Ajouter
      </v-btn>
      <v-btn class="mx-2" small @click="close">
        Annuler
      </v-btn>
    </template>
  </custom-dialog>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { uploadDocument } from '@/services/services/documentsService';
import CustomDialog from '@/components/dialogs/CustomDialog';
import { catchCRUDError } from '@/business/apiTreatment/response/errorTreatment';

const { mapGetters, mapActions } = createNamespacedHelpers('documents');

export default {
  name: 'UploadDocumentDialog',
  components: { CustomDialog },
  data: () => ({
    file: null,
    title: '',
    comment: '',
    nature: null,
    visible: false,
    valid: false,
    isLoading: false,
  }),
  props: {
    action: Boolean,
  },
  computed: {
    ...mapGetters(['propertyId', 'actionId', 'categories']),
    groupId() {
      return this.$store.getters['global/groupId'];
    },
    categoriesItems() {
      return this.categories.reduce(
        (res, category) =>
          res.concat([
            { header: category.title },
            ...category.natures.map((nature) => ({
              text: `${category.title} - ${nature.title}`,
              value: nature.id,
            })),
          ]),
        []
      );
    },
  },
  methods: {
    ...mapActions(['loadItems']),
    uploadDocument,
    add() {
      this.isLoading = true;
      const params = {
        propertyId: this.propertyId,
        title: this.title,
        nature: this.nature,
        visible: this.visible,
        comment: this.comment,
        file: this.file,
        groupId: this.groupId,
        action: this.action,
        actionId: this.actionId,
      };

      this.uploadDocument(params)
        .then(() => {
          this.isLoading = false;
          this.loadItems();
          this.close();
        })
        .catch((err) => {
          this.isLoading = false;
          this.$store.dispatch(
            'snackbar/setSnackbarOpen',
            catchCRUDError('ADD', err)
          );
        });
    },
    close() {
      this.file = null;
      this.title = '';
      this.comment = '';
      this.nature = null;
      this.visible = false;
      this.$refs.form.resetValidation();
      this.$refs.dialog.handleCloseClick();
    },
  },
  watch: {
    file(val) {
      if (val && this.title === '') {
        this.title = val.name.slice(0, val.name.lastIndexOf('.'));
      }
    },
  },
};
</script>
